<div class="buyer-details">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h6 class="mb-0">Buyer Details</h6>
    <a *ngIf="canAdd && !showForm" class="badge light badge-success c-pointer" (click)="openAdd()">Add Buyer</a>
  </div>

  <!-- Add / Edit form -->
  <form *ngIf="showForm" [formGroup]="buyerForm" (ngSubmit)="submitBuyer()" autocomplete="off" class="mb-4">
    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Buyer Name <span class="text-danger">*</span></label>
        <input type="text" class="form-control" formControlName="buyer_name" placeholder="Buyer name"
          [class.is-invalid]="buyerForm.get('buyer_name')?.invalid && buyerForm.get('buyer_name')?.touched" />
        <div class="invalid-feedback" *ngIf="buyerForm.get('buyer_name')?.invalid && buyerForm.get('buyer_name')?.touched">
          Buyer name is required
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label">Email</label>
        <input type="email" class="form-control" formControlName="email" placeholder="email@example.com"
          [class.is-invalid]="buyerForm.get('email')?.invalid && buyerForm.get('email')?.touched" />
        <div class="invalid-feedback" *ngIf="buyerForm.get('email')?.invalid && buyerForm.get('email')?.touched">
          Enter a valid email
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label">Phone</label>
        <input type="text" class="form-control" formControlName="phone" placeholder="Phone" />
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label">Amount</label>
        <input type="number" class="form-control" formControlName="amount" placeholder="Sale / agreed amount" />
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label">Purchase Date</label>
        <input type="date" class="form-control" formControlName="purchase_date" />
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label">ID Proof Type</label>
        <input type="text" class="form-control" formControlName="id_proof_type" placeholder="e.g. Aadhaar, PAN" />
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label">ID Proof Number</label>
        <input type="text" class="form-control" formControlName="id_proof_number" placeholder="ID number" />
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label">Address</label>
        <input type="text" class="form-control" formControlName="address" placeholder="Buyer address" />
      </div>
      <div class="col-12 mb-3">
        <label class="form-label">Notes</label>
        <textarea class="form-control" formControlName="notes" rows="3" placeholder="Additional notes"></textarea>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-danger light" (click)="cancelForm()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="loadingService.isLoading()">
        {{ editingUid ? 'Update Buyer' : 'Add Buyer' }}
      </button>
    </div>
  </form>

  <!-- Buyers list -->
  <div class="table-responsive" *ngIf="!showForm">
    <table class="table mb-0">
      <thead>
        <tr>
          <th>Name</th>
          <th>Phone</th>
          <th>Email</th>
          <th>Amount</th>
          <th>Purchase Date</th>
          <th class="text-end" *ngIf="canEdit || canDelete">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let buyer of buyers">
          <td>{{ buyer.buyer_name }}</td>
          <td>{{ buyer.phone || '-' }}</td>
          <td>{{ buyer.email || '-' }}</td>
          <td>{{ buyer.amount || '-' }}</td>
          <td>{{ buyer.purchase_date || '-' }}</td>
          <td class="text-end" *ngIf="canEdit || canDelete">
            <a *ngIf="canEdit" class="badge light badge-primary me-2 c-pointer" (click)="openEdit(buyer)">Edit</a>
            <a *ngIf="canDelete" class="badge light badge-danger c-pointer" (click)="deleteBuyer(buyer.uid)">Delete</a>
          </td>
        </tr>
        <tr *ngIf="buyers.length === 0">
          <td [attr.colspan]="(canEdit || canDelete) ? 6 : 5" class="text-center text-muted">
            No buyer details added yet.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
